import { registerPlugin } from '@capacitor/core';
const MoECapacitorGeofence = registerPlugin('MoECapacitorGeofence', {});
export * from './definitions';
export { MoECapacitorGeofence };
//# sourceMappingURL=index.js.map